module.exports = __webpack_public_path__ + "img/logo_alpha.56d01c91.png";